activ.directive('libraryGridView', function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: "./views/libraryGridView.html?v=" + version,
        scope: true,
        link: function(scope, element, attrs) {

        }
    };
});